import { Component } from 'react'

import { HoverChart } from '../shared/components/HoverChart'
import { ETF_MARKET_CAP_LABEL, colors, sizes, xys } from './selects'
import HoverStore from './stores/hoverStore'
import { formatValue } from './utils'

interface BubblesHoverProps {
  labelX: string
  labelY: string
  labelSize: string
  labelColor: string
}

class BubblesHover extends Component<BubblesHoverProps> {
  state = { shown: false }

  componentDidMount() {
    HoverStore.addChangeListener(this._onChange)
    document.addEventListener('mousemove', this._onMouseMove)
  }

  componentWillUnmount() {
    HoverStore.removeChangeListener(this._onChange)
    document.removeEventListener('mousemove', this._onMouseMove)
  }

  _onChange = () => {
    this.setState({
      shown: !!HoverStore.getHoveredNode(),
    })
  }

  render() {
    if (!this.state.shown) {
      return null
    }

    // so we don't have duplicates
    var vals: Record<string, { label: string; value: string | number; format?: string }> = {}
    var hoveredNode = HoverStore.getHoveredNode()

    var x = xys.find((o) => o.value === this.props.labelX)
    if (x) {
      vals[x.value] = { label: x.label, value: hoveredNode.x, format: x.format }
    }

    var y = xys.find((o) => o.value === this.props.labelY)
    if (y) {
      vals[y.value] = { label: y.label, value: hoveredNode.y, format: y.format }
    }

    var size = sizes.find((o) => o.value === this.props.labelSize)
    if (size) {
      vals[size.value] = { label: size.label, value: hoveredNode.size }
    }

    var color = colors.find((o) => o.value === this.props.labelColor)
    if (color) {
      vals[color.value] = { label: color.label, value: hoveredNode.color, format: color.format }
    }

    return (
      <div
        id="hover-bubbles"
        className="fixed z-dialog flex min-w-[300px] flex-col bg-[#494f5e] p-px font-sans text-2xs text-white"
      >
        <div className="bold border-b border-[#444957] px-2 uppercase leading-7 text-white">{hoveredNode.company}</div>
        <div className="flex justify-between">
          <div className="space-y-2 p-2">
            {Object.keys(vals).map((key) => {
              const isETFMarketCap = hoveredNode.isETF && key === 'marketCap'
              const label = isETFMarketCap ? ETF_MARKET_CAP_LABEL : vals[key].label
              const value = formatValue(vals[key].value, vals[key].format, true)

              if (!['sector', 'order', 'ticker', 'const'].includes(key)) {
                return (
                  <div key={key}>
                    <h3 className="m-0 text-3xs uppercase leading-tight text-[#8a95b1]">{label}</h3>
                    <span className="font-normal">{value}</span>
                    <br />
                  </div>
                )
              }

              return null
            })}
          </div>
          <HoverChart key={hoveredNode.ticker} ticker={hoveredNode.ticker} />
        </div>
      </div>
    )
  }

  _onMouseMove = (e: MouseEvent) => {
    if (!this.state.shown) {
      return
    }
    var marginLeft = 100
    var marginTop = 0
    var el = document.getElementById('hover-bubbles')!
    var hoverWidth = Math.max(el.scrollWidth, 467)
    var hoverHeight = Math.max(el.scrollHeight, 213)
    var availWidth = document.documentElement.clientWidth
    var availHeight = document.documentElement.clientHeight
    if (e.clientX + hoverWidth + marginLeft * 1.5 < availWidth) {
      el.style.left = e.clientX + marginLeft + 'px'
    } else if (e.clientX - hoverWidth - marginLeft > 0) {
      el.style.left = e.clientX - marginLeft - hoverWidth + 'px'
    } else {
      marginLeft = 20
      if (e.clientX + hoverWidth + marginLeft < availWidth) {
        el.style.left = e.clientX + marginLeft + 'px'
      } else {
        el.style.left = e.clientX - marginLeft - hoverWidth + 'px'
      }
    }
    el.style.top =
      Math.max(0, e.clientY + marginTop - Math.max(0, e.clientY + marginTop + hoverHeight - availHeight)) + 'px'
  }
}

export default BubblesHover
